import * as React from 'react';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Toast({ message = '', callback = () => {} }) {
    const [variant, setVariant] = React.useState('success');
    const [anchorOrigin, setAnchorOrigin] = React.useState({
        horizontal: 'center',
        vertical: 'bottom'
    });
    const [open, setOpen] = React.useState(true);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
    };

    React.useEffect(() => {
        setTimeout(() => {
            setOpen(false);
            callback();
        }, 3000);
    }, [callback]);

    return (
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={anchorOrigin}>
            <Alert onClose={handleClose} severity={variant} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
}
